import SearchInput from './SearchInput.component';

export default SearchInput;
